@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">District Of Columbia</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span class="axis-error-block">Please select an option.</span>
            }
          }
        }
      </div>
      @if (baseRules["Show_Other_Coverage"]?.includes("show")) {
        <div class="axis-form-group _mt-medium">
          <p class="axis-text">{{ textValues.Medical_Expense_Benefits_Text }}</p>
        </div>

        @if (baseRules["levelTwo_Radio"]?.includes("show")) {
          <div
            class="axis-form-group _ml-medium _mt-medium"
            [ngClass]="{
              'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
              'has-axis-error':
                reactiveForm.get(controls[1].formControlName)?.touched &&
                reactiveForm.get(controls[1].formControlName)?.invalid,
            }"
          >
            <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
              @for (control of controls[1].option; track $index) {
                <axis-radio
                  class="{{ control.class }}"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[1].formControlName }}"
                ></axis-radio>
              }
            </axis-radio-button-wrapper>
            @if (reactiveForm.get(controls[1].formControlName)?.touched) {
              @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                <span class="axis-error-block">Please select an option.</span>
              }
            }
          </div>
        }
        @if (
          baseRules["MedicalExpenseBenefits_DropDown"]?.includes("show") ||
          baseRules["MedicalExpenseBenefits_DropDown"]?.includes("form")
        ) {
          <div class="axis-grid _ml-medium _mt-medium">
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(controls[3].formControlName)?.value === null ||
                    reactiveForm.get(controls[3].formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(controls[3].formControlName)?.touched &&
                    reactiveForm.get(controls[3].formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ controls[3].formControlName }}"
                  >{{ controls[3].label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="controls[3].data"
                  id="{{ controls[3].formControlName }}"
                  formControlName="{{ controls[3].formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(controls[3].formControlName)?.touched) {
                  @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
                    <span class="axis-error-block">Please select an option.</span>
                  }
                }
              </div>
            </div>
          </div>
        }

        <div class="axis-form-group _mt-medium">
          <p class="axis-text">{{ textValues.Work_Loss_Benefits_Text }}</p>
        </div>

        @if (baseRules["levelThree_Radio"]?.includes("show")) {
          <div
            class="axis-form-group _ml-medium _mt-medium"
            [ngClass]="{
              'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
              'has-axis-error':
                reactiveForm.get(controls[2].formControlName)?.touched &&
                reactiveForm.get(controls[2].formControlName)?.invalid,
            }"
          >
            <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
              @for (control of controls[2].option; track $index) {
                <axis-radio
                  class="{{ control.class }}"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[2].formControlName }}"
                ></axis-radio>
              }
            </axis-radio-button-wrapper>
            @if (reactiveForm.get(controls[2].formControlName)?.touched) {
              @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
                <span class="axis-error-block">Please select an option.</span>
              }
            }
          </div>
        }
        @if (
          baseRules["WorkLossBenefits_DropDown"]?.includes("show") ||
          baseRules["WorkLossBenefits_DropDown"]?.includes("form")
        ) {
          <div class="axis-grid _ml-medium _mt-medium">
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(controls[4].formControlName)?.value === null ||
                    reactiveForm.get(controls[4].formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(controls[4].formControlName)?.touched &&
                    reactiveForm.get(controls[4].formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ controls[4].formControlName }}"
                  >{{ controls[4].label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="controls[4].data"
                  id="{{ controls[4].formControlName }}"
                  formControlName="{{ controls[4].formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(controls[4].formControlName)?.touched) {
                  @if (reactiveForm.get(controls[4].formControlName)?.invalid) {
                    <span class="axis-error-block">Please select an option.</span>
                  }
                }
              </div>
            </div>
          </div>
        }

        @if (!baseRules["FuneralExpenseBenefits_Checkbox"]?.includes("hide")) {
          @if (baseRules["OtherCoverage_LevelOne_Radio"]?.includes("show")) {
            <div class="axis-grid _mt-large">
              <div class="_ml-medium _mb-medium">
                <axis-checkbox
                  [formControlName]="controls[9].formControlName"
                  FuneralExpenseBenefits_Checkbox
                  [heading]="controls[9].label"
                ></axis-checkbox>
              </div>
            </div>
          } @else {
            @if (baseRules["FuneralExpenseBenefits_Checkbox"]?.includes("No")) {
              <div class="axis-form-group">
                <label class="axis-control-label">
                  {{ textValues.Funeral_Expense_Reject_Text }} {{ textValues?.Accepted }}
                </label>
              </div>
            }
          }
        }
      }
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">District Of Columbia</h2>
  @if (baseRules["AllCoveragePersonalInjuryProtection_LevelOne_Radio"]?.includes("Yes")) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.AllRejected }}
      </label>
    </div>
  }
  @if (baseRules["MedicalExpenseBenefitsMax_DropDown"]?.includes("show")) {
    <div class="axis-form-group">
      <label
        class="axis-control-label"
        for="{{ controls[5].formControlName }}"
        >{{ controls[5].label }}</label
      >
      <div>{{ controls[5].data[0].name }}</div>
    </div>
  }
  @if (baseRules["MedicalExpenseBenefitsMin_DropDown"]?.includes("show")) {
    <div class="axis-form-group">
      <label
        class="axis-control-label"
        for="{{ controls[7].formControlName }}"
        >{{ controls[7].label }}</label
      >
      <div>{{ controls[7].data[0].name }}</div>
    </div>
  }

  @if (baseRules["WorkLossBenefitsMax_DropDown"]?.includes("show")) {
    <div class="axis-form-group">
      <label
        class="axis-control-label"
        for="{{ controls[6].formControlName }}"
        >{{ controls[6].label }}</label
      >
      <div>{{ controls[6].data[0].name }}</div>
    </div>
  }
  @if (baseRules["WorkLossBenefitsMin_DropDown"]?.includes("show")) {
    <div class="axis-form-group">
      <label
        class="axis-control-label"
        for="{{ controls[8].formControlName }}"
        >{{ controls[8].label }}</label
      >
      <div>{{ controls[8].data[0].name }}</div>
    </div>
  }

  @if (baseRules["FuneralExpenseBenefits_Checkbox"]?.includes("No")) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Funeral_Expense_Reject_Text }} {{ textValues?.Accepted }}
      </label>
    </div>
  }
}
